/*
 * The Knowledge Files table's treatment, which the admin settings tables are meant to read
 * like: header labels at body size in the muted colour rather than the small subdued step,
 * body cells at body size in the plain foreground, and a hairline under every row.
 *
 * Written as overrides on the table element, the way that table writes them — each rule
 * outranks the primitive's own because a class plus an attribute selector beats a bare class.
 */
/* eslint-disable i18next/no-literal-string -- Tailwind class names, not copy */
export const ADMIN_TABLE_STYLES = [
  '**:data-[slot=datatable-head]:text-body-md',
  '**:data-[slot=datatable-head]:font-normal',
  '**:data-[slot=datatable-head]:text-muted-foreground',
  '**:data-[slot=datatable-cell]:py-sm',
  '**:data-[slot=datatable-cell]:text-body-md',
  '**:data-[slot=datatable-cell]:font-normal',
  '**:data-[slot=datatable-cell]:text-foreground',
  '**:data-[slot=datatable-cell]:border-b',
  '**:data-[slot=datatable-cell]:border-border-light',
].join(' ');
/* eslint-enable i18next/no-literal-string */
